import React, { FC } from "react";
import { Alert } from "antd";
import { AlertMessage } from "./alert-message";

export type AlertMessageBannerProps = AlertMessage & {
  banner?: boolean;
};

export const AlertMessageBanner: FC<AlertMessageBannerProps> = ({
  banner,
  type,
  message,
  description,
  onClose,
}) => {
  return (
    <Alert
      banner={banner}
      type={type}
      message={message}
      description={description}
      onClose={onClose || (() => {})}
      closable={false}
    />
  );
};
